import { USER_LOGIN_RESET } from '../../redux/user/userConstants';
import React, { useEffect } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import * as yup from "yup";
import { useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../../redux/user/userActions";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
const validationSchema = yup.object().shape({
    rememberMe: yup.boolean(),
    mobileNumber: yup
        .string("شماره موبایل خود را وارد کنید")
        .required("شماره موبایل الزامی می باشد.")
        .matches(/^[0-9]+$/, "شماره موبایل تنها شامل اعداد است.")
        .min(11, "شماره موبایل شامل 11 رقم می باشد.")
        .max(11, " شماره موبایل شامل 11 رقم می باشد."),
    password: yup.string().required("وارد نمودن رمز عبور الزامی است."),
});
const useStyles = makeStyles(() => ({
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "bold",
    },
}));
export const SignIn = (props) => {
    const [loginMobileValue, setLoginMobileValue] = React.useState(null);
    const [loginMobilePassword, setLoginMobilePassword] = React.useState(null);
    const [show, setShow] = React.useState(true);

    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch();
    const classes = useStyles();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    let history = useHistory();
    function Alert(msg) {
        switch (msg) {
            case "UserIsBlocked":
                return props.failed(
                    "اکانت شما به طور موقت غیر فعال شده است لطفا به پشتیبانی مراجعه کنید"
                );
            case "AccessDenied":
                return props.failed("خطا در دسترسی");
            case "RunTimeError":
                return props.failed("خطا حین ارسال اطلاعات، لطفا اطلاعات وارد شده را بررسی و مجددا عملیات را تکرار فرمایید.");
            case "IsLockedOut":
                return props.failed("لطفا دقایقی دیگر تلاش کنید");
            case "IsDatasIncorrected":
                return props.failed("رمز عبور یا شماره موبایل شما اشتباه میباشد.");
            case "UserNotFound":
                return props.failed("کاربر یافت نشد ، لطفا ثبت نام کنید.");
        }
    }
    useEffect(() => {
        if (userInfo) {
            setLoading(false);
            if (userInfo.status === "ok") {
                localStorage.setItem("token", userInfo.token);
                props.success("با موفقیت وارد شدید");
                props.onClose();
                window.location.reload();
                /*
                if (props.redirect) {
                    history.push("/profile")
                }
                */
            }
            if (userInfo.status === "error") {
                Alert(userInfo.message);
                dispatch({ type: USER_LOGIN_RESET });
            }
        }
    }, [userInfo]);

    const handleClickShowPassword = () => {
        setShow(!show);
    };

    const handleMouseDownPassword = (event) => {
        setShow(false);
    };


    const handeler = () => { };
    return (
        <Formik
            style={{ width: "100%" }}
            initialValues={{
                mobileNumber: "",
                password: "",
                rememberMe: false,
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                setLoading(true);

                dispatch(login(values)).then(() => handeler());
            }}
            render={({ handleSubmit, handleChange, values, touched, errors }) => (
                <form onSubmit={handleSubmit}>
                    <Box px={3}>
                        <label className={classes.label}>شماره تلفن همراه</label>
                        <TextField
                            fullWidth
                            name="mobileNumber"
                            variant="outlined"
                            value={values.mobileNumber}
                            onChange={handleChange}
                            error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                            helperText={touched.mobileNumber && errors.mobileNumber}
                        />
                        <label className={classes.label}>رمز عبور</label>
                        <TextField
                            dir="ltr"
                            type={show ? 'password' : 'text'}
                            fullWidth
                            name="password"
                            variant="outlined"
                            value={values.password}
                            onChange={handleChange}
                            error={touched.password && Boolean(errors.password)}
                            helperText={touched.password && errors.password}
                            InputProps={{
                                endAdornment: (<InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {show ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>)
                            }}
                        />
                        <Box mt={1}>
                            <Field type="checkbox" name="rememberMe" id="rememberMe" />
                            <label for="rememberMe" className="form-check-label">
                                مرا به خاطر بسپار
                            </label>
                            <ErrorMessage
                                name="rememberMe"
                                component="div"
                                className={classes.red} />
                        </Box>
                        <Box mt={2} textAlign="center">
                            <Button
                                type="submit"
                                disabled={loading}
                                variant="contained"
                                className="w-90 "
                                color="secondary">
                                {loading ? <CircularProgress /> : "ورود"}
                            </Button>
                        </Box>
                    </Box>
                </form>
            )}
        />
    );
};
